export const MAX_CONFIG_NAME_LENGTH = 48

export class ConfigNameValidationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ConfigNameValidationError'
  }
}

export const trimConfigName = (value: unknown): string => String(value ?? '').trim()

export const getConfigNameLength = (value: string): number => Array.from(value).length

export const truncateConfigName = (value: string, maxLength = MAX_CONFIG_NAME_LENGTH): string => {
  return Array.from(value).slice(0, maxLength).join('')
}

export const normalizeConfigName = (value: unknown, fallback = ''): string => {
  const name = trimConfigName(value) || trimConfigName(fallback)
  if (!name) throw new ConfigNameValidationError('config name is required')
  if (getConfigNameLength(name) > MAX_CONFIG_NAME_LENGTH) throw new ConfigNameValidationError('config name is too long')
  return name
}
